import { render, staticRenderFns } from "./IcoPin.vue?vue&type=template&id=707c91da"
import script from "./IcoPin.vue?vue&type=script&lang=js"
export * from "./IcoPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports